import { Link } from "react-router-dom";
import Icon from "@/components/Icon";
import { Reveal } from "@/lib/motionSafe";
import { useSettings } from "@/lib/useSettings";

export default function ServicesGrid({ services = [] }) {
  const { settings } = useSettings();
  const title = settings?.services_section_title_ar || "حلول أمنية متكاملة تناسب كل احتياج";
  const desc =
    settings?.services_section_desc_ar ||
    "من الكاميرات إلى الشبكات، نغطي كل زوايا الحماية بتقنيات معتمدة وفريق فني مدرّب. اختر الخدمة لمعرفة التفاصيل والحصول على عرض سعر.";
  return (
    <section id="services" className="py-20 md:py-28 bg-white" data-testid="services-section">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <Reveal>
          <div className="max-w-2xl">
            <span className="aman-tag-dark">خدماتنا</span>
            <h2 className="font-heading mt-4 text-3xl sm:text-4xl lg:text-5xl font-bold text-[#0A1628] leading-tight">
              {title}
            </h2>
            <p className="mt-4 text-slate-600 leading-relaxed">{desc}</p>
          </div>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 mt-14" data-testid="services-grid">
          {services.map((svc, i) => (
            <Reveal key={svc.slug} delay={i * 80}>
              <Link
                to={`/services/${svc.slug}`}
                className="aman-card group block overflow-hidden h-full"
                data-testid={`service-card-${svc.slug}`}
              >
                <div className="grid grid-cols-5 h-full">
                  {/* Image */}
                  <div className="col-span-2 relative min-h-[220px]">
                    {svc.hero_image ? (
                      <img
                        src={svc.hero_image}
                        alt={svc.title_ar}
                        className="absolute inset-0 w-full h-full object-cover"
                        loading="lazy"
                      />
                    ) : (
                      <div className="absolute inset-0 bg-slate-100" />
                    )}
                    <div className="absolute inset-0 bg-gradient-to-t from-[#0A1628]/60 via-transparent to-transparent" />
                    <div className="absolute top-4 start-4 w-11 h-11 rounded-xl bg-[#0A1628]/85 backdrop-blur border border-white/10 text-[#00E5FF] flex items-center justify-center">
                      <Icon name={svc.icon} size={22} />
                    </div>
                  </div>
                  {/* Text */}
                  <div className="col-span-3 p-6 sm:p-7 flex flex-col">
                    <h3 className="font-heading text-xl sm:text-2xl font-bold text-[#0A1628] leading-tight">
                      {svc.title_ar}
                    </h3>
                    <p className="mt-3 text-slate-600 text-sm leading-relaxed line-clamp-3">
                      {svc.short_desc_ar}
                    </p>
                    <div className="mt-auto pt-5 flex items-center gap-1.5 text-[#0A1628] font-semibold text-sm group-hover:text-[#00b8cc] transition-colors">
                      اكتشف الخدمة
                      <Icon name="chevron-left" size={16} strokeWidth={2.5} />
                    </div>
                  </div>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
